import { render, staticRenderFns } from "./breadCrumbs.vue?vue&type=template&id=023ff05a&scoped=true"
import script from "./breadCrumbs.vue?vue&type=script&lang=js"
export * from "./breadCrumbs.vue?vue&type=script&lang=js"
import style0 from "./breadCrumbs.vue?vue&type=style&index=0&id=023ff05a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023ff05a",
  null
  
)

export default component.exports